import request from '../../utils/request';

export type WismoParams = null;
export function doGetWismoStats() {
  return request(`/dashboard/wismo`, {
    method: 'GET',
  });
}
